// mapbox-lib
import * as Constants from './constants';
import MapboxDraw from '@mapbox/mapbox-gl-draw';

import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

const DrawPoint = MapboxDraw.modes.draw_point;
const DrawPointGPSMode = { ...DrawPoint };

DrawPointGPSMode.onSetup = function () {
    const point = this.newFeature({
        type: Constants.geojsonTypes.FEATURE,
        properties: {},
        geometry: {
            type: Constants.geojsonTypes.POINT,
            coordinates: [],
        },
    });

    this.addFeature(point);

    this.clearSelectedFeatures();
    this.updateUIClasses({ mouse: Constants.cursors.ADD });
    this.activateUIButton(Constants.types.POINT);

    this.setActionableState({
        trash: true,
    });

    return { point };
};

DrawPointGPSMode.onClick = DrawPointGPSMode.onClick = function (state, e) {
    return;
};
DrawPointGPSMode.onTap = DrawPointGPSMode.onClick = function (state, e) {
    return;
};

export default DrawPointGPSMode;
